import { Text, useDisclosure } from '@chakra-ui/react';
import React from 'react';

import Modal from '../../../../../components/Modal';
import Button from '../../../../../components/ui/buttons/Button';
import { DealWithFarthestState } from '../../../utils';
import StepCard from '../StepCard';
import {
  PostSigningStep,
  StepState,
  formatStartedOnDate,
  getStepDescriptionColor,
  getStepIconOpacity,
  getStepLabelColor,
} from '../utils';

type Props = {
  step: PostSigningStep;
  deal?: DealWithFarthestState;
  isCompleted: boolean;
  isCurrent: boolean;
  isLast: boolean;
};

const PostSigningStepContent = ({ step, deal, isCompleted, isCurrent, isLast }: Props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const state: StepState = isCurrent ? 'current' : isCompleted ? 'past' : 'future';

  const labelColor = getStepLabelColor({ isCompleted, isCurrent, isPayoffFailed: false });
  const descriptionColor = getStepDescriptionColor({ isCurrent, isPayoffFailed: false });
  const iconOpacity = getStepIconOpacity({ isCompleted, isCurrent });

  const startedOn = formatStartedOnDate(deal);
  const subtitle =
    isCurrent && !isLast && startedOn ? (
      <Text
        fontSize={{ base: 'xs', md: 'sm' }}
        color="gray.600"
        fontStyle="italic"
        fontWeight="light"
        mt={0.5}
      >
        In progress since {startedOn}
      </Text>
    ) : undefined;

  const { ModalBody } = step;

  return (
    <>
      <StepCard
        icon={step.icon}
        iconProps={{ opacity: iconOpacity, ...step.iconProps }}
        label={step.label}
        labelProps={{ color: labelColor }}
        isCompleted={isCompleted}
        subtitle={subtitle}
        description={step.subCopyByState[state]}
        descriptionProps={{ color: descriptionColor }}
        belowDescription={
          isCurrent && (
            <Button
              variant="link"
              size="sm"
              mt={1}
              color="leaseEndBlue"
              fontWeight="semibold"
              onClick={onOpen}
            >
              Learn More
            </Button>
          )
        }
      />
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title={step.label}
        titleFontSize="20px"
        titleFontWeight="bold"
      >
        <ModalBody deal={deal} />
      </Modal>
    </>
  );
};

export default PostSigningStepContent;
